import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-saved-searches',
  templateUrl: './contact-saved-searches.component.html',
  styleUrls: ['./contact-saved-searches.component.scss']
})
export class ContactSavedSearchesComponent {
}
